import axios from "axios";
import { serviceConfig } from "configs";

const API_BASE_URL = serviceConfig.apiUrl;

export const wishlistService = {
	addToWishlist: async (
		productId: string,
		userId: string
	): Promise<{ success: boolean; message: string }> => {
		const response = await axios.post(`${API_BASE_URL}/wishlist`, {
			productId,
			userId,
		});
		return response.data;
	},

	removeFromWishlist: async (
		productId: string,
		userId: string
	): Promise<{ success: boolean; message: string }> => {
		const response = await axios.delete(
			`${API_BASE_URL}/wishlist/${productId}`,
			{
				data: { userId }, // important for DELETE with body
			}
		);
		return response.data;
	},

	getWishlist: async (
		userId: string
	): Promise<{ success: boolean; data: any[] }> => {
		const response = await axios.get(`${API_BASE_URL}/wishlist`, {
			params: { userId },
		});
		return response.data;
	},
};
